import { faArrowUpRightFromSquare, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { CubeSections, Intermediate } from "../report/Report";
import { useWorkspaceKavel } from "./kavel";

// Hetzelfde rapport als op /location, maar als paneel over de kaart: zo blijf je
// in de workspace, met je gesprek en je filter, en zie je ernaast liggen waar
// het perceel ligt. CubeSections verwacht alleen een cube — die heeft de
// kavelstore al opgehaald.
export const ReportDrawer = () => {
  const { state, cube, error, gps, showReport, hideReport } = useWorkspaceKavel();
  if (!showReport || !state) return null;

  return (
    <aside className="absolute inset-y-0 right-0 z-20 flex w-full max-w-[26rem] flex-col border-l bg-white shadow-xl">
      <div className="flex items-center gap-2 border-b px-3 py-2">
        <span className="flex-1 truncate text-sm font-bold">{cube?.name || "Perceel"}</span>
        {gps && (
          <Link
            to={`/location/${gps[0].toFixed(5)},${gps[1].toFixed(5)}`}
            target="_blank"
            rel="noreferrer"
            className="text-gray-400 hover:text-black"
            title="Open het rapport in een nieuw tabblad"
          >
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="sm" />
          </Link>
        )}
        <button
          onClick={hideReport}
          className="text-gray-400 hover:text-black"
          title="Sluiten"
          aria-label="Sluiten"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      {/* `relative` op het scrollgebied: de titel in de hero is absoluut
          gepositioneerd en zou anders aan dit paneel hangen en dus blijven
          staan terwijl de tekst eronder doorscrolt. */}
      <div className="relative min-h-0 flex-1 overflow-y-auto">
        {state === "fetched" && cube ? (
          <CubeSections cube={cube} embedded />
        ) : (
          <Intermediate state={state} cube={cube} error={error} />
        )}
      </div>
    </aside>
  );
};
